import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  TIndirectTaxListCustomerTransactionsParams,
  TIndirectTaxTransactionExtend,
  TIndirectTaxTransactionListResponse,
} from './types';

export function useIndirectTaxCustomerTransactions({
  corporationId,
  customerId,
  limit = 100,
  cursor = null,
}: TIndirectTaxListCustomerTransactionsParams) {
  const query = new URLSearchParams();
  query.append('corporationId', corporationId.toString());
  if (customerId) {
    query.append('customerId', customerId);
  }
  query.append('limit', limit.toString());
  query.append(
    'extend',
    `${TIndirectTaxTransactionExtend.SHIPPING_ADDRESS},${TIndirectTaxTransactionExtend.CUSTOMER},${TIndirectTaxTransactionExtend.SHIP_FROM_ADDRESS}`
  );
  if (cursor) {
    query.append('cursor', cursor);
  }

  const { data, error, isLoading, mutate } =
    useSWR<TIndirectTaxTransactionListResponse>(
      customerId && corporationId != null
        ? `new-sales-tax/transactions?${query}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined),
      {
        keepPreviousData: true,
      }
    );

  return {
    data: data
      ? {
          transactions: data.data,
          nextCursor: data.nextCursor,
          totalTransactions: data.totalTransactions,
        }
      : undefined,
    isLoading,
    error,
    mutate,
  };
}
